import { Reveal } from "@/components/Reveal";

const STEPS = [
  "Budget",
  "Department / Cost Head",
  "Vendor / Resource",
  "Commercial Commitment",
  "Actual Expense",
  "Audit & Verification",
  "Invoice / Document",
  "Accounting Entry",
  "Payment / Reconciliation",
  "Project Cost",
  "Final Cost Report",
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="relative overflow-hidden border-t border-white/10 bg-[#0a0a0a] py-24 md:py-32">
      <img
        src="/assets/veritas-seal.png"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute -left-48 bottom-10 h-[620px] w-[620px] select-none opacity-[0.04] mix-blend-lighten"
      />
      <div className="relative mx-auto grid max-w-[1440px] grid-cols-1 gap-16 px-5 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <p className="mb-4 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.28em] text-[#D4AF37]">
                <span className="h-px w-10 bg-[#B79045]" /> The Process
              </p>
              <h2 className="font-display text-4xl font-medium leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
                One Data Flow — From{" "}
                <em className="italic text-[#D4AF37]">Budget</em> to{" "}
                <em className="italic text-[#D4AF37]">Final Cost</em>
              </h2>
              <p className="mt-6 max-w-md text-sm leading-relaxed text-neutral-400 md:text-base">
                Every transaction has a financial trail. Every project gets one
                connected financial picture.
              </p>
              <p className="mt-10 font-mono text-xs uppercase tracking-[0.3em] text-neutral-600">
                11 Steps · Single Ledger
              </p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7">
          <ol className="relative border-l border-[#B79045]/25 pl-8 md:pl-12">
            {STEPS.map((step, i) => (
              <Reveal key={step} delay={i * 0.04} y={24}>
                <li
                  data-testid={`process-step-${String(i + 1).padStart(2, "0")}`}
                  className="group relative flex items-baseline gap-6 border-b border-white/5 py-5 md:py-6"
                >
                  <span className="absolute -left-8 top-1/2 h-px w-5 bg-[#B79045]/40 transition-[width] duration-500 group-hover:w-8 md:-left-12 md:w-8" />
                  <span className="font-mono text-sm font-bold text-[#B79045] md:text-base">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-display text-xl text-neutral-200 transition-colors duration-300 group-hover:text-white md:text-3xl">
                    {step}
                  </span>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
